import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {UtilsService} from './utils/utils.service';
import {SiteDTO} from './dtos/site-dto';
import {Observable, Subject} from 'rxjs';
import {SiteRoutemapService} from './services/entities/site-routemap.service';
import {ResponseWrapper} from 'app/core/suppliers/wrappers/response-wrapper';
import { HttpClient } from '@angular/common/http';
import {HttpService} from "./services/technique/http.service";

export const URL_findSitesLocauxSansUniteDeProductionByUser = `dolrest/sites/findSitesLocauxSansUniteDeProductionByUser`;

@Injectable()
export class SiteService {


  // Le Subject

  private subjectOpenDialog = new Subject<SiteDTO>();
  openDialog$ = this.subjectOpenDialog.asObservable();

  siteSubjectToDelete = new Subject<SiteDTO>();
  siteSubjectToDelete$ = this.siteSubjectToDelete.asObservable();

  constructor(private http: HttpClient,
              private httpSvc: HttpService,
              private utils: UtilsService,
              private siteRouteMapService: SiteRoutemapService) {
  }


  /**
   * cf. SiteController#findAllActifs
   * @returns {Observable<SiteDTO[]>}
   */
  getListeSitesActifs = (): Observable<SiteDTO[]> => {
    return this.httpSvc.get('dolrest/sites/findAllActifs');
  };

  /**
   * Recherche des Site actifs ayant au moins 1 ContratMenu actif.
   * @returns {Observable<SiteDTO[]>}
   */
  findAllActifsWithContratMenu = (): Observable<SiteDTO[]> => {
    return this.http.get<SiteDTO[]>('dolrest/sites/findAllActifsWithContratMenu').pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  };

  searchTerms = new Subject<string>();

  // Service message commands
  announceSearch = (term: string) => {
    this.searchTerms.next(term);
  };


  searchSite = (endUrl: string): Observable<SiteDTO[]> => this.httpSvc.get(this.siteRouteMapService.getSearchSitesLink(endUrl), null);

  /**
   * Recherche des Sites locaux de l'utilisateur connecté.
   */
  findSitesLocauxSansUniteDeProductionByUser = (): Observable<SiteDTO[]> => {
    return this.http.get<SiteDTO[]>(URL_findSitesLocauxSansUniteDeProductionByUser).pipe(
      catchError(error => this.utils.handleError(error, true)),
    );
  };

  /**
   * Raffraichissement du tableau de SiteDTO passé en paramètre.
   * @param {SiteDTO[]} sitesForGrille
   * @param {SiteDTO} site
   * @returns {SiteDTO[]}
   */
  refreshSiteGrille = (sitesForGrille: SiteDTO[], site: SiteDTO): SiteDTO[] => {
    let arr = [];
    let isFoundSiteArr = sitesForGrille.filter(item => site && item.id === site.id);

    if (isFoundSiteArr && isFoundSiteArr.length > 0) {
      sitesForGrille.map(item => {
        if (site && item.id === site.id) {
          item = site;
        }
        arr.push(item);
      });
    }
    else {

      sitesForGrille.unshift(site);
      sitesForGrille.map(item => arr.push(item));
    }

    return arr;
  };

  deleteSite = (siteIdList: number[]): Observable<any> => {
    return this.httpSvc.delete(`dolrest/sites/delete?idsToDelete=${siteIdList.join(',')}`, null);
  };

  save = (siteDTO: SiteDTO): Observable<ResponseWrapper<SiteDTO>> => {
    return this.httpSvc.post("dolrest/sites/site/saveone", siteDTO);
  };

  announceSiteToDelete = (siteDTO: SiteDTO) => {
    this.siteSubjectToDelete.next(siteDTO);
  };

  announceOpenDialogEdition = (site: SiteDTO) => {
    this.subjectOpenDialog.next(site);
  };

}





